module.exports = __webpack_public_path__ + "static/media/Nguyen_Anh_Duc.9a54b540.PNG";